export default __webpack_public_path__ + "static/media/Rigel_Smart_Living_Logo_Black@2x.0e3574f9.png";